import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconBoltFillComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-Bolt_Fill${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><path d="M2.269 6.455L4.489.68a.278.278 0 01.259-.18h3.724a.28.28 0 01.253.396l-1.381 3.05a.28.28 0 00.253.394H9.22c.229 0 .36.261.224.446l-4.86 6.6c-.176.24-.552.074-.497-.217l.754-4.002a.279.279 0 00-.273-.33h-2.04a.28.28 0 01-.26-.38z" fill={useCurrentColor ? 'currentColor' : '#FE2C55'}/></svg>;
}

const IconBoltFill = React.forwardRef(IconBoltFillComponent);
export default IconBoltFill;
